var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_vm._m(0),_c('div',[_c('v-divider')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('p',[_vm._v("Controle de Trocas")])])
}]

export { render, staticRenderFns }